module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (242).f26acac7.jpg";